import React, { useRef } from 'react'

type AllowedInputTypes = 'password' | 'text' | 'number' | 'tel'

type InputProps = Required<
  Pick<
    React.InputHTMLAttributes<HTMLInputElement>,
    | 'value'
    | 'onChange'
    | 'aria-label'
    | 'maxLength'
    | 'autoComplete'
    | 'inputMode'
    | 'dir'
  > & {
    ref: React.RefObject<HTMLInputElement>
    className: string | undefined
    type: AllowedInputTypes
  }
>

function OTPSingleInput({
  renderInput,
  onChange,
  value,
  maxLength,
  shouldAutoFocus,
}: {
  renderInput: (inputProps: InputProps) => React.ReactNode
  onChange: (otp: string) => void
  value: string
  maxLength: number
  shouldAutoFocus: boolean
}) {
  const ref = useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    if (shouldAutoFocus) {
      ref.current?.focus()
    }
  }, [shouldAutoFocus])

  return (
    <>
      {renderInput({
        autoComplete: 'off',
        'aria-label': `Please enter OTP code`,
        inputMode: 'numeric',
        onChange: e => {
          onChange(e.target.value)
        },
        value,
        ref,
        type: 'tel',
        className: undefined,
        maxLength,
        dir: value ? 'ltr' : 'inherit',
      })}
    </>
  )
}

export default OTPSingleInput
